import React, { useEffect, useState } from 'react';
import {
    AttachDocumentsContainer,
    AttachDocumentsContent,
    AttachDocumentsHeader,
    AttachDocumentsForm,
    AttachDocumentsButtons
} from './styles';
import AttachDocumentsItem from './AttachDocumentItem';
import {
    SecondaryLargeButton,
    DefaultLargeButton
} from '../../components/Buttons/styles';
import { H4, H5 } from '../../components/Typography/styles';
import colors from '../../assets/styles/colors';
import Loader from '../../components/Loader';

import { useHistory } from 'react-router';
import { getAlertsByCredit } from '../../services/credit';
import { completeTask, getIdProcess, uploadFileOnBase } from '../../services/documentsBpm';
import { formatData } from '../../helpers/date';
import { toBase64 } from '../../helpers/base64';
import ModalInfo from '../../components/ModalInfo';
import { BsExclamation } from 'react-icons/bs';
import ModalAction from '../../components/ModalAction';
import { IoIosAlert, IoIosCheckmarkCircle } from 'react-icons/io';

const options = [
    {
        id: 1,
        title: 'Penúltima declaración de renta',
        paragraph: 'Carga la penúltima declaración de renta',
        inputLabel: 'penultima_renta'
    },
    {
        id: 2,
        title: 'Última declaración de renta',
        paragraph: 'Carga la última declaración de renta',
        inputLabel: 'ultima_renta'
    },
    {
        id: 3,
        title: 'Certificado ingresos y retenciones',
        paragraph: 'Carga el certificado de ingresos y retenciones',
        inputLabel: 'ingresos_retenciones'
    },
    {
        id: 4,
        title: 'Formato conocimiento cliente PEP',
        paragraph: 'Carga el formato conocimiento cliente PEP',
        inputLabel: 'cliente_pep'
    }
]


const AttachDocumentsPage = () => {
    const history = useHistory();
    const [fileCounter, setFileCounter] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [alerts, setAlerts] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [formData, setFormData] = useState([]);
    const [showModalInfoError, setShowModalInfoError] = useState(false);
    const [titleErrorOnFile, setTitleErrorOnFile] = useState('');
    const [messageErrorOnFile, setMessageErrorOnFile] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [modalStep, setModalStep] = useState(1);

    const credito = history.location.item;

    async function initializedStateComponent() {
        try {
            setShowModal(true);
            const alertas = await getAlertsByCredit(credito?.id);
            //let alertasSolicitadas = options.filter(item => alertas.data.soportesRequeridos[0].descripcionDocumento.includes(item?.title));
            let alertasSolicitadas = [];
            for (let i = 0; i < alertas.data.soportesRequeridos?.length; i++) {
                const soporte = alertas.data.soportesRequeridos[i];
                const nuevosAlertas = soporte.descripcionDocumento.map((descripcion, index) => ({
                    alerta: soporte.alerta,
                    id: index + 1,
                    title: descripcion,
                    paragraph: `Carga: ${descripcion.toLowerCase()}`,
                    inputLabel: descripcion.replace(/\s+/g, '_').toLowerCase()
                }));
                alertasSolicitadas = alertasSolicitadas.concat(nuevosAlertas);
            }

            console.log(alertasSolicitadas);
            setAlerts(alertasSolicitadas);
            setIsLoading(false);
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    }

    const handleFileChange = (inputLabel, file, operador, nombreAlerta) => {
        setFormData((prevFormData) => [
            ...prevFormData,
            { nombreArchivo: inputLabel, archivo: file, alerta: nombreAlerta },
        ]);
        console.log("formData: " + JSON.stringify(formData));
        console.log({ nombreArchivo: inputLabel, archivo: file, alerta: nombreAlerta });
        operador ? setFileCounter((prevCounter) => prevCounter + 1) : setFileCounter((prevCounter) => prevCounter - 1);
    };

    const onCompleteTask = async () => {
        try {
            setIsLoading(true);
            let req = {
                idCredito: credito?.id,
                identificacion: credito?.cliente?.identificacion,
                tipoDocumental: "Riesgo LAFT",
                archivo: null
            }
            let envioTareaCompleta = false;
            for (let i = 0; i < formData.length; i++) {
                let fileConverted = await toBase64(formData[i].archivo);
                let req = {
                    idCredito: credito?.id,
                    identificacion: credito?.cliente?.identificacion,
                    tipoDocumental: "Riesgo LAFT",
                    archivo: fileConverted
                }
                if (formData[i].nombreArchivo === "penúltima_declaración_de_renta") {
                    req.tipoDocumental = "Declaracion de Renta PEP"
                }
                if (formData[i].nombreArchivo === "última_declaración_de_renta") {
                    req.tipoDocumental = "Declaracion de Renta PEP"
                }
                if (formData[i].nombreArchivo === "certificado_ingresos_y_retenciones") {
                    req.tipoDocumental = "Certificacion de ingresos"
                }
                if (formData[i].nombreArchivo === "formato_conocimiento_cliente_pep") {
                    req.tipoDocumental = "Formato de identificación PEP"
                }
                console.log(formData[i])
                if (formData[i].alerta === "laft") {
                    req.tipoDocumental = "Riesgo LAFT"
                }

                let response = await uploadFileOnBase(req);

                if (response.data.statusCode == 200 && !envioTareaCompleta) {
                    let process = await getIdProcess(credito?.id);
                    let payload = {
                        idCredit: credito?.id,
                        idProcess: process.data,
                        taskName: "Gestión documentos Digicredito",
                        genericVariables: [
                            {
                                name: "documentosCargados",
                                type: "Boolean",
                                value: true
                            }
                        ]
                    };

                    let response = await completeTask(payload);
                    envioTareaCompleta = true;
                    /*setTitleErrorOnFile(`Error al subir el archivo: ${formData[i].archivo?.name}, reintentar`);
                    setIsLoading(false);
                    setShowModalInfoError(true);
                    return;*/
                    
                }
            }

            /*let process = await getIdProcess(credito?.id);
            let payload = {
                idCredit: credito?.id,
                idProcess: process.data,
                taskName: "Gestión documentos Digicredito",
                genericVariables: [
                    {
                        name: "documentosCargados",
                        type: "Boolean",
                        value: true
                    }
                ]
            };

            let response = await completeTask(payload);*/
            setIsLoading(false);
            moveToDashboard();
        } catch (e) {
            console.log(e);
            setIsLoading(false);
        }
    }

    function modalErrorResetDefault() {
        setShowModalInfoError(false)
        setMessageErrorOnFile('');
        setTitleErrorOnFile('');
    }

    function moveToDashboard() {
        history.push({
            pathname: '/admin/dashboard/'
        });
    }

    const handleConfirm = async () => { setModalStep(2); }

    const handleDesist = async () => {
        let process = await getIdProcess(credito?.id);
        let payload = {
            idCredit: credito?.id,
            idProcess: process.data,
            taskName: "Gestión documentos Digicredito",
            genericVariables: [
                {
                    name: "documentosCargados",
                    type: "Boolean",
                    value: false
                }
            ]
        };
        try {
            setIsLoading(true);
            let response = await completeTask(payload);
            console.log(response);
            handleNavigate('./dashboard');
            setIsLoading(false);
        } catch (e) {
            console.log(e);
            setIsLoading(false);
            handleNavigate('./dashboard');
        }
    }

    const handleNavigate = (path) => {
        history.push(path);
    }

    const handleBack = () => {
        history.push('./pendientes_adjuntar')
    }

    useEffect(() => {
        initializedStateComponent();
    }, []);


    return (
        <AttachDocumentsContainer>
            <AttachDocumentsContent>
                <AttachDocumentsHeader>
                    <H4 color={colors.textPrimary}>Pendientes por Adjuntar</H4>
                </AttachDocumentsHeader>
                {isLoading && <Loader />}
                <AttachDocumentsForm>
                    {
                        alerts.length ?
                            alerts.map((item, i) =>
                                <AttachDocumentsItem
                                    title={item.title}
                                    paragraph={item.paragraph}
                                    key={i}
                                    inputlabel={item.inputLabel}
                                    credito={credito}
                                    files={formData[item.inputLabel]}
                                    onFileChange={handleFileChange}
                                    alerta={item.alerta}
                                />)
                            : <H5>Este credito no posee documentos a subsanar</H5>
                    }
                </AttachDocumentsForm>

                <AttachDocumentsButtons>
                    <DefaultLargeButton onClick={handleBack}>Volver</DefaultLargeButton>
                    <SecondaryLargeButton disabled={!(fileCounter == alerts.length)} onClick={onCompleteTask}>Enviar</SecondaryLargeButton>
                </AttachDocumentsButtons>
            </AttachDocumentsContent>
            {showModal &&
                modalStep <= 1 ?
                <ModalAction
                    open={showModal}
                    title='Confirmación de gestión'
                    description="Al confirmar la gestion podras realizar el cargue de documentos pendientes para finalizar el proceso."
                    setShowModal={setShowModal}
                    actionLabelFunctionUpButton='Confirmar'
                    actionLabelFunctionDownButton='Desistir'
                    actionFunctionUpButton={() => handleConfirm()}
                    actionFunctionDownButton={() => handleDesist()}
                    bodyIcon={<IoIosAlert size={100} color={colors.bgDanger} />}
                /> :
                <ModalAction
                    open={showModal}
                    title='!Muy bien!'
                    description="A partir de la fecha tendrás 30 días para adjuntar los documentos, transcurrido este tiempo la solicitud será negada. Recuerda que puede haber cambio de condiciones y/o actualización de las consultas durante este tiempo."
                    setShowModal={setShowModal}
                    actionLabelFunctionUpButton='Continuar'
                    actionLabelFunctionDownButton='Cerrar'
                    actionFunctionUpButton={() => setShowModal(false)}
                    actionFunctionDownButton={() => { setShowModal(false) }}
                    bodyIcon={<IoIosCheckmarkCircle size={100} color={colors.bgSuccess} />}
                />
            }
            <ModalInfo
                open={showModalInfoError}
                setShowModal={modalErrorResetDefault}
                title={titleErrorOnFile}
                description={messageErrorOnFile}
                backgroundIcon={colors.bgDanger}
                bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
        </AttachDocumentsContainer>
    )
}

export default AttachDocumentsPage;